import { FC } from "react";
import { IconButton, Stack, Tooltip } from "@mui/material";

import AddIcon from '@mui/icons-material/Add';
import { GetMaskUrl } from "../EditMaskStructure/EditMaskStructure";

interface MissingMaskComponentProps {
    maskName: string;
    addFromMissing: (name: string) => void;
}

const MissingMaskComponent: FC<MissingMaskComponentProps> = ({ maskName, addFromMissing }) => {
    return (
        <Stack
            direction={"row"}
            justifyContent="space-between"
            alignItems="flex-start"
            sx={{ marginBottom: "7px", padding: "5px", border: "1px black solid" }}>
            <Stack>
                <Tooltip
                    title={
                        <Stack direction={"column"} sx={{ backgroundColor: "white" }}>
                            <img
                                src={GetMaskUrl(maskName.toString())}
                                height={"200px"}
                                loading="lazy"
                            />
                        </Stack>
                    }>
                    <span>Name: {maskName}</span>
                </Tooltip>

            </Stack>
            <IconButton
                color="primary"
                size="large"
                sx={{ width: "30px", height: "30px" }}
                onClick={() => { addFromMissing(maskName) }}>
                <AddIcon />
            </IconButton>
        </Stack>
    )
}

export default MissingMaskComponent;